import { EMPTY_OBJECT } from '@app/consts/common_consts';
import { FieldPath, FieldValues } from 'react-hook-form';
import { signify } from 'react-signify';

export const FORM_NAME_DEFAULT = 'FORM_DEFAULT';
export type DisabledFields<TFieldValues extends FieldValues = FieldValues> = {
  [key in FieldPath<TFieldValues>]: boolean;
};

export type DisabledFieldsSignifyType<TFieldValues extends FieldValues = FieldValues> = {
  [key: string]: DisabledFields<TFieldValues>;
};
export const disabledFieldsSignify = signify<DisabledFieldsSignifyType>({
  [FORM_NAME_DEFAULT]: EMPTY_OBJECT,
});
